'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuSubmenu = require('deku-submenu');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	active: {
		type: 'number'
	},
	class: {
		type: 'string'
	},
	data: {
		type: 'array'
	},
	onChange: {
		type: 'function'
	},
	showHidden: {
		type: 'boolean'
	},
	'toggler': {
		'type': 'string'
	}
};

var defaultProps = {
	titleLink: true,
	onlyLinkClicks: false,
	showHidden: false,
	toggler: ''
};

var onClick = function onClick(onChange) {
	return function (e) {
		return onChange && onChange(e);
	};
};

var getItems = function getItems(arr, active, _ref) {
	var onChange = _ref.onChange,
	    onlyLinkClicks = _ref.onlyLinkClicks,
	    showHidden = _ref.showHidden,
	    titleLink = _ref.titleLink,
	    toggler = _ref.toggler;

	return arr.map(function (x) {
		if (x.hidden_flg && !showHidden) {
			return (0, _magicVirtualElement2.default)('noscript', null);
		}

		if (!x.children || x.children.length === 0) {
			return (0, _magicVirtualElement2.default)(
				_dekuSubmenu.MenuItem,
				{ active: x.cat_id === active, 'class': 'MenuItem--level' + x.level },
				(0, _magicVirtualElement2.default)(
					'a',
					{ href: '/' + x.link_friendly_name, onClick: onClick(onChange) },
					x.catname
				)
			);
		}

		var items = getItems(x.children, active, { onChange: onChange, onlyLinkClicks: onlyLinkClicks, showHidden: showHidden, titleLink: titleLink });
		var activeChildItems = items.filter(function (item) {
			return item.attributes.active;
		});
		var title = titleLink ? (0, _magicVirtualElement2.default)(
			'a',
			{ href: '/' + x.link_friendly_name },
			x.catname
		) : x.catname;

		return (0, _magicVirtualElement2.default)(
			_dekuSubmenu.SubMenu,
			{ toggler: toggler, title: title, active: x.cat_id === active || activeChildItems.length, 'class': 'MenuItem--level' + x.level, onClick: !onlyLinkClicks && onClick(onChange) },
			items
		);
	});
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var active = props.active,
	    data = props.data,
	    onChange = props.onChange,
	    onlyLinkClicks = props.onlyLinkClicks,
	    showHidden = props.showHidden,
	    titleLink = props.titleLink,
	    toggler = props.toggler;


	return (0, _magicVirtualElement2.default)(
		_dekuSubmenu.Menu,
		{ 'class': props.class },
		getItems(data, active, { onChange: onChange, onlyLinkClicks: onlyLinkClicks, showHidden: showHidden, titleLink: titleLink, toggler: toggler })
	);
};

exports.default = { defaultProps: defaultProps, propTypes: propTypes, render: render };